import React, {useState} from "react";
// import logo from "./../assets/logo-black.png";
import axios from "axios";
// import cognismilesLogo from './../assets/black-logo.png'
import cognismilesLogo from './../assets/Logo transparent bg 250px.png'
import { toast } from "react-toastify";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const ForgotPassword = () => {
  const [email_id, setEmail_id] = useState("");
  const [isPaying, setIsPaying] = useState(false)
  const [error, setError] = useState("");

  const {executeRecaptcha} = useGoogleReCaptcha()

  const googleCaptcha = async () => {
         try {
             const token = await executeRecaptcha()
           // If token is available, proceed with form submission
           if (token) {
             // Send form data with token to your server
             console.log('TOKEN:', token)
             const response = await axios.post(`${process.env.REACT_APP_API_URL}api/v1/verifyRecaptcha`, {token})
             console.log(response,'success captcha')
             return true;
           } else {
             console.log('TOKEN-Error', token)
             console.log('Ref')
             return false;
           }
         } catch (error) {
           console.log('Something went wrong:', error)
           return false;
         }
 }


  const handleSubmit = async (e) => {
    e.preventDefault();
    const validation = await googleCaptcha();
    if (!validation) {
        setError("Oops! something went wrong, please try again")
        return;
    }
    const apiUrl = `${process.env.REACT_APP_API_URL}api/v1/forgot-password`;
    const data = { email_id };
    setIsPaying(true);
    axios.post(apiUrl, data, {withCredentials:true})
    .then(response => {
        console.log('Response:', response.data);
       toast.success("Email sent successfully!")
        setEmail_id("");
        setIsPaying(false);
        setError("")
    })
    .catch(error => {
        setError(error?.response?.data?.result?.message)
        console.error('Error:', error);
        setIsPaying(false);
    });
}
  
  return (
    <section class="bg-gray-50  font-pop">
      <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <div class="w-full p-6 bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md  sm:p-8">
        <img className="w-[80px] py-2 h-auto mx-auto" src={cognismilesLogo} alt="logo" />
          <h1 className="mt-3 text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl ">
            Forgot Password
          </h1>
          <form class="mt-4 space-y-4 lg:mt-5 md:space-y-5" onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="email_id"
                className="block mb-2 font-medium text-primary "
              >
                Your email
              </label>
              <input
                type="email"
                name="email_id"
                value={email_id}
                className="outline-none shadow-sm border border-gray-300 text-gray-900 sm:text-sm rounded-lg  block w-full p-2.5 "
                // onChange={(e) => {
                //   const containsOtherChars = e.target.value.match(/[^0-9a-zA-Z@.]/)
                //   if(containsOtherChars){
                //     setEmail_id(containsOtherChars?.input?.slice(0,containsOtherChars.index))
                //   }else{
                //     setEmail_id(e?.target?.value)
                //   }
                // }}
                onChange={(e) => {
                  setEmail_id(e?.target?.value)
                } }
                placeholder="name@company.com"
                required
              />
            </div>
      
            {/* <div class="flex items-start">
                  <div class="flex items-center h-5">
                    <input id="newsletter" aria-describedby="newsletter" type="checkbox" class="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300" required />
                  </div>
                  <div class="ml-3 text-sm">
                    <label htmlFor="newsletter" class="text-gray-700 ">I accept the <span class="font-medium text-blue-600 hover:underline  cursor-pointer">Terms and Conditions</span></label>
                  </div>
              </div> */}
              {error && <p className="text-red-500 text-sm font-medium">{error}</p>}
            <button
              type="submit"
              className="w-full text-white bg-secondary focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center "
            >
                                     {isPaying
                            ? <svg
                                aria-hidden="true"
                                className="inline w-5 h-5 text-gray-100 animate-spin  fill-blue-400"
                                viewBox="0 0 100 101"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                >
                                <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="currentColor"
                                    />
                                <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="currentFill"
                                    />
                              </svg>
                            : 'Send'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
